import ListKeyConditions from "../../../components/condition/view/keyConditions";
import React, {useState} from "react";
import {PreviewKeyConditionController} from "./controller";
import BackTextComponent from "../../../components/BackTextComponent";
import {AuthZTable, defaultPageSize, defaultPageSizeOptions} from "../../../components/authZTable";
import {TextWithSubTitle} from "../../../components/textWithSubTitle";
import "./index.css";

function PreviewKeyCondition({match}) {
  const {userGroupUniqueName, userGroupTypeUniqueName, conditionId} = match.params;
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(defaultPageSize);
  const {keyCondition, backClick, data, columns, isLoading, totalElements, rowClassNameFn} =
    PreviewKeyConditionController(
      userGroupUniqueName,
      userGroupTypeUniqueName,
      conditionId,
      page,
      size,
    );

  let modifiedColumns = columns?.map((column) => {
    let {title, render, tableFilter, ...restKeys} = column;
    if (render === "TextWithSubTitleComponent") {
      render = (content) => {
        return <TextWithSubTitle titles={[content.first, content.second]}/>;
      };
    }
    if (typeof render == "function") {
      return {
        ...restKeys,
        width: 200,
        title: title,
        render: render,
        searchEnabled: false,
        sortEnabled: false,
        filterEnabled: false,
      };
    } else {
      return {
        ...restKeys,
        width: 200,
        title: title,
        searchEnabled: false,
        sortEnabled: false,
        filterEnabled: false,
      };
    }
  });

  const onPageChange = (current) => {
    setPage(current);
  };

  function changePageSize(size) {
    setSize(size);
  }

  return (
    <div className="key-member-container">
      <div className="key-member-content-container">
        <BackTextComponent
          backText={"Back"}
          clickFunctionality={backClick}
        />
        <ListKeyConditions listOfKeyConditions={keyCondition}/>
        <div className="key-member-table">
          <div className="key-member-table-header">
            People who match the above condition ({totalElements})
          </div>
          <AuthZTable
            name="member-list"
            id={conditionId}
            rowKey={"key"}
            columns={modifiedColumns}
            dataSource={data}
            loading={isLoading}
            rowClassName={rowClassNameFn}
            pagination={{
              showSizeChanger: true,
              showQuickJumper: true,
              pageSize: size,
              pageSizeOptions: defaultPageSizeOptions,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
              current: page,
              total: totalElements,
              onShowSizeChange: (current, pageSize) => changePageSize(pageSize, current),
              onChange: (current) => onPageChange(current),
            }}
            scroll={{x: "max-content", y: "calc(64vh)"}}
          />
        </div>
      </div>
    </div>
  );
}

export default PreviewKeyCondition;
